"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledNumericInput = require("./StyledNumericInput");
var _NumericInput = _interopRequireDefault(require("./NumericInput"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _classnames = _interopRequireDefault(require("classnames"));
var _StyledTextInput = require("../TextInput/StyledTextInput");
var _excluded = ["style", "disabled", "mobile", "validationItem", "className", "precision", "integerMode", "backgroundColorType", "size", "width", "addonAfter"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var NumberInput = /*#__PURE__*/function (_React$Component) {
  function NumberInput() {
    var _this;
    (0, _classCallCheck2.default)(this, NumberInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NumberInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      focused: false
    });
    return _this;
  }
  (0, _inherits2.default)(NumberInput, _React$Component);
  return (0, _createClass2.default)(NumberInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        style = _this$props.style,
        disabled = _this$props.disabled,
        mobile = _this$props.mobile,
        validationItem = _this$props.validationItem,
        className = _this$props.className,
        precision = _this$props.precision,
        integerMode = _this$props.integerMode,
        backgroundColorType = _this$props.backgroundColorType,
        size = _this$props.size,
        width = _this$props.width,
        addonAfter = _this$props.addonAfter,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      delete rest.validation;
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledNumericInput.StyledNumericInputContainer, {
          width: width,
          disabled: disabled,
          className: (0, _classnames.default)(className, {
            'table-xs': size === 'xsmall'
          }),
          style: style,
          theme: theme,
          $backgroundColorType: backgroundColorType,
          addonAfter: addonAfter
        }, /*#__PURE__*/_react.default.createElement(_StyledNumericInput.NumberInputContainer, {
          customAddonAfter: addonAfter,
          size: size
        }, /*#__PURE__*/_react.default.createElement(_NumericInput.default, (0, _extends2.default)({
          noValidate: true,
          inputMode: "numeric",
          integerMode: integerMode,
          precision: integerMode ? 0 : precision,
          disabled: disabled,
          mobile: mobile,
          theme: theme,
          backgroundColorType: backgroundColorType,
          size: size,
          customAddonAfter: addonAfter
        }, rest, {
          strict: true
        })), addonAfter && /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputAddon, {
          className: "addon-after"
        }, addonAfter)));
      });
    }
  }]);
}(_react.default.Component);
NumberInput.displayName = 'NumberInput';
NumberInput.propTypes = {
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  precision: _propTypes.default.number,
  mobile: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  integerMode: _propTypes.default.bool,
  width: _propTypes.default.string,
  addonAfter: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};
NumberInput.defaultProps = {
  min: 0,
  max: 9007199254740991,
  step: 1,
  mobile: false,
  size: 'medium',
  precision: null,
  disabled: false,
  integerMode: false
};
var _default = exports.default = (0, _inputHOC.default)(NumberInput);